import {  PersonalCard, Prerenderbg, Prerenderbg2 } from "../../../assets";
import { numberWithCommas } from "../../../core/utils";
import { Button, Input, Layout } from "../../components";
import { PrePaymentController } from "../../controllers";
import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";


class PrePayment extends PrePaymentController {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        const {  price, loading, error } = this.state;
        return (
            <Layout title="پیش پرداخت ها">
                <Helmet>
        <title>پیش پرداخت ها | بیمه زندگی هامرز </title>
      </Helmet>
                <div className="pre-payment scrollbar">
                <img src={Prerenderbg2} alt="هامرز" className="img-fluid hide-desktop bg-img-mobile" />

                    <div className="info-group">
                        <span className="pre-payment-title">
                            لطفا مبلغ پیش پرداخت را وارد کنید.
                        </span>
                        {/* <div className="supply">
                            <p className="supply-p" >
                             موجودی کیف پول شما

                            </p>
                            <p className="supply-p">
                               ۳۴,۰۰۰,۰۰۰ {" "} ریال
                            </p>
                        </div> */}
                       
                        <div className="w-100 mb-5">

                            <Input hasComma hideEndAdornment type="number" max="13" error={error.filter((name: { path: string; }) => name.path === "price")?.[0]?.errors?.[0]} myStyle="w-100" title="مبلغ به ریال" value={price} onChange={(e: any) => this.setState({ price: e })} icon={<PersonalCard />} />
                            <div className="price-group">
                                <span className="item cursor-pointer ms-1" onClick={() => this.setState({ price: 500000 })}> {numberWithCommas(500000)} {" "} <span className="unit">
                                    ریال</span></span>
                                <span className="item cursor-pointer ms-1" onClick={() => this.setState({ price: 250000000 })}> {numberWithCommas(250000000)} {" "} <span className="unit">
                                    ریال</span></span>
                                <span className="item cursor-pointer " onClick={() => this.setState({ price: 500000000 })}> {numberWithCommas(500000000)} {" "} <span className="unit">
                                    ریال</span></span>
                            </div>
                        </div>


                        <div className="d-flex justify-content-end w-100">
                            <Button myStyle="bg-blue pre-payment-btn" title="پرداخت" onClick={() => this.createPreFactor()} loading={loading} />
                        </div>

                    </div>
                    <div className="terms-container hide-mobile">
                        <img src={Prerenderbg} alt="هامرز" className="img-fluid bg-img " />
                        <div className="terms-card">
                            <div className="custom-dash">
                                <span className="span">
                                    در نظر داشته باشید پیش پرداخت باید با نام بیمه گذار پرداخت گردد
                                </span>
                                <span>
                                    در وارد نمودن مبلغ و اطلاعات دقت نمایید در صورت پرداخت امکان بازگشت وجود ندارد
                                </span>
                                <span>
                                    پس از وارد کردن اطلاعات با یکی از روش های پرداخت نسبت به پرداخت اقدام نمایید.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }
}

const mapStateToProps = (dispatch: any) => {
    return {
        dispatch,
        userData: dispatch.general.userData,

    };
};
export default connect(mapStateToProps)(PrePayment);
